import { createCRUDService } from "./createCRUDService";

const BranchService = createCRUDService("branch", {
  listBranches: "list-branch",
  createBranch: "create-branch",
  updateBranch: "update-branch",
  deleteBranch: "delete-branch",
  getAllBanks: "get-banks",
  getAllBranches: "get-branches",
});

export default BranchService;
